import { Record } from 'immutable';
import {
  ADD_IPS,
  CLEAR_IPS,
  FETCH_HISTORY_SEEDS,
  FETCH_IPLIST,
} from './constants';

const InitialState = Record({
  ipList: { ips: [] },
  discoveryHistorySeeds: {},
});

const initialState = new InitialState();

function discoverySeedReducer(state = initialState, action = undefined) {
  switch (action.type) {
    // used in Wizard Configuration only
    case `${FETCH_IPLIST}_SUCCESS`:
      return state.set('ipList', { ips: action.payload.ipList });
    // used in Wizard Configuration only
    case `${ADD_IPS}_SUCCESS`: {
      return state.set('ipList', { ips: action.payload });
    }
    case `${CLEAR_IPS}_SUCCESS`:
      return state.set('ipList', { ips: [] });
    case `${FETCH_HISTORY_SEEDS}_SUCCESS`:
      return state.set('discoveryHistorySeeds', action.payload.data ?? {});
    default:
      return state;
  }
}

export default discoverySeedReducer;
